module.exports = __webpack_public_path__ + "media/images/front/event_publish_lp/icon_site_01-826ff7ba5cbae62c561b263c5959be5c.png";